class ObjectUtils {
  public static DeepClone<T>(toClone: T): T {
    return toClone && (JSON.parse(JSON.stringify(toClone)) as T);
  }
}

export default ObjectUtils;
